module.exports = __webpack_public_path__ + "media/images/icons/outlined/shrink-5de4f1a9bb20c936e3cf74f56705121b.svg";